const username = () => {
	switch (process.env.BRAND_ID) {
		case 'VM':
		case 'CB':
			return 'C20022292';
		case 'YB':
			return 'Y20002292';
	}
};

export default {
	id: '1234567890',
	username: username(),
	dob: '1985-01-13',
	gender: 'F',
	segment: 'B',
	sub_segment: '',
	contact_preference: 'EMAIL',
	name: {
		title: 'Mr',
		first_name: 'Joe',
		middle_name: '',
		last_name: 'Bloggs',
	},
	addresses: [
		{
			uk_address: {
				address_prefix: '2/1',
				house_number: '39',
				house_name: '',
				street_name: 'High Street',
				address_line_1: '2/1, 39 High Street, Glasgow, G11 1CB',
				address_line_2: '',
				city: 'Glasgow',
				postal_code: 'G11 1CB',
				county: '',
			},
			preferred: true,
			status: 'temporary',
			residential_status: 'owner',
			effective_period: {
				from: '2011-03-07T00:00:00.001Z',
				to: '2011-03-07T00:00:00.001Z',
			},
		},
	],
	phone_numbers: [
		{
			type: 'M',
			phone_number: '0123456789',
			preferred: true,
		},
	],
	email_addresses: [
		{
			type: 'B',
			value: 'joebloggs@abcdef.com',
			preferred: true,
		},
	],
	tandcs: [
		{
			'<service name>': {
				version: '0.3.4',
				accepted_at: 'iso datetime',
				isOmniChannel: true,
			},
		},
	],
	customers: [
		{
			customer_id: '20037855-f07c-4298-80c6-f5a9a5e966a',
			role: 'DELEGATE_USER',
			actions_available: {
				'/users/<various>': true / false,
			},
		},
	],
};
